import React, { useEffect, useState } from "react";
import Wrapper from "@/scenes/_shared/stages/wrapper";
import useRadioInput, { RadioInput } from "@/components/form/radio-input";
import useNumberInput, { NumberInput } from "@/components/form/number-input";
import useFileInput, { FileInput, FileList } from "@/components/form/file-input";

const S12 = (props) => {
    const radio = useRadioInput({
        name: "sale[price_correction]", label: "Har du mottatt et kostnadsoverslag/pristilbud på utbedring?",
        options: {
            data: [
                { label: "Ja", value: "TRUE" },
                { label: "Nei", value: "FALSE" },
            ],
        },
        tooltip: "Den som fremmer et krav har bevisbyrden for det kravet man mener å ha. Det betyr at det er ditt ansvar å dokumentere hva som er feil og hva det vil koste å utbedre. Eksempel på dette kan være å innhente et skriftlig pristilbud og rapport fra et verksted.",
        ...props,
    })

    const price = useNumberInput({
        name: "sale[expenses]", label: "Hva er den totale kostnaden?",
        placeholder: "Fyll inn",
        tooltip: "Har du mottatt et skriftlig kostnadsoverslag/pristilbud kan du gjerne laste opp dette her.",
        ...props,
        disabled: props?.disabled || radio.is("FALSE"),
    })

    const file = useFileInput({
        required: false,
        multiple: true,
        options: {
            label: {
                force: true,
            },
        },
    })

    return (
        <Wrapper {...props} header="Kostnadsdokumentasjon">
            <RadioInput {...radio.props}/>
            <div className="group gg-3 sm-gg-0 mt-7">
                <NumberInput {...price.props}/>
                <FileInput {...file}/>
            </div>
            <FileList className="mt-3"/>
        </Wrapper>
    );
};

export default S12;
